import urls, { stringifyParams } from './urls';

/** Coding systems supported by the Zori AI Codings system filter. */
export const ZORI_CODINGS_KNOWN_SYSTEMS = new Set([
  'http://loinc.org',
  'http://lifeomic.com/fhir/extracted-data',
  'http://lifeomic.com/fhir/screening',
  'http://lifeomic.com/fhir/truage',
  'http://lifeomic.com/fhir/dexa',
  'http://lifeomic.com/fhir/cleerly-test-code',
  'http://lifeomic.com/fhir/jona',
  'http://lifeomic.com/fhir/amra',
  'http://lifeomic.com/fhir/viome',
  'http://lifeomic.com/fhir/functional',
  'all',
]);

export type ZoriCodingsReviewCoding = {
  code?: string;
  system?: string;
  display?: string;
};

/**
 * Resolve a lab coding system to a Codings panel filter value.
 * Unknown systems fall back to `all` so search is not stuck on LOINC.
 */
export function resolveZoriCodingsSystemFilter(
  system: string | undefined,
): string {
  if (system && ZORI_CODINGS_KNOWN_SYSTEMS.has(system)) {
    return system;
  }
  return 'all';
}

/**
 * Build a deep-link into Zori AI → Codings with search pre-filled from a lab coding.
 * Returns null when there is no usable query text.
 */
export function buildZoriCodingsReviewUrl(
  coding: ZoriCodingsReviewCoding,
): string | null {
  const query = (coding.display || coding.code || '').trim();
  if (!query) {
    return null;
  }

  const system = resolveZoriCodingsSystemFilter(coding.system);
  return urls.app.workflows.zoriRules('codings', { query, system });
}

/** @internal Exposed for tests that assert query-string shape without going through urls. */
export function buildZoriCodingsReviewSearch(
  coding: ZoriCodingsReviewCoding,
): string {
  const query = (coding.display || coding.code || '').trim();
  const system = resolveZoriCodingsSystemFilter(coding.system);
  return stringifyParams({ query, system });
}
